module.exports = "<img src=\"./assets/images/enconstruction.png\"/>\n"